module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_3016.e91c2c33.png";